import React, { useEffect, useState } from "react";
import { MdAdd } from "react-icons/md";
import CustomAccordion from "../../../components/customAccordion";
import CustomModal from "../../../components/customModal";
import CustomInputField from "../../../components/customInputField";
import toast from "react-hot-toast";

const Faq = ({ faqs }) => {
  const [modal, setModal] = useState(false);
  const [faqInput, setFaqInput] = useState({ question: "", answer: "" });
  const faqHandler = (e) => {
    const { name, value } = e.target;
    setFaqInput((prev) => ({ ...prev, [name]: value }));
  };
  const submitHanlder = () => {
    if(!faqInput.answer || !faqInput.question){
      toast.error("Field must be fullfilled");
      return;
    }
    console.log("added faq :", faqInput);
  };

  const modalClose = () => setModal(false);
  const modalOpen = () => setModal(true);
  console.log("faq data :", faqInput);
  // modal body
  const renderBody = () => {
    return (
      <div className="edit-profile-body-container">
        <div className="faq-modal-child-container">
          <div>
            <label htmlFor="question" className="lable-text">
              {"Question"}
            </label>
            <textarea
              id="question"
              name="question"
              value={faqInput.question}
              onChange={faqHandler}
              rows="3"
              className="form-control"
              placeholder="Enter question"
            />
          </div>
          <div>
            <label htmlFor="answer" className="lable-text">
              {"Answer"}
            </label>
            <textarea
              id="answer"
              name="answer"
              value={faqInput.answer}
              onChange={faqHandler}
              rows="5"
              className="form-control"
              placeholder="Enter answer"
            />
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="faq--container">
      <span
        className="btn btn-primary btn-sm add-btn add-btn-container accordian--add--btn"
        onClick={modalOpen}
      >
        <span>{"Add"}</span>
        <span className="add-icon">
          <MdAdd />
        </span>
      </span>
      <div className="accordion--container">
        <CustomAccordion datas={faqs} />
      </div>
      <CustomModal
        visible={modal}
        visibleHandler={modalClose}
        heading={"Add new faq"}
        body={renderBody}
        confirmHandler={submitHanlder}
        modalSize={"lg"}
        confirmText={"Add"}
        footershow={true}
        closeText="Back"
      />
    </div>
  );
};

export default Faq;
